export default __webpack_public_path__ + "static/media/arrow-down.50c4c943.svg";